import { Grid, TextField } from '@mui/material'
import { forwardRef, ForwardedRef } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { CustomHorizontalTextField } from '.'
import { EFInputLabel } from '../EFInputLabel'
import { EFHorizontalTextFieldProps } from './EFTextField.model'
import classNames from 'classnames/bind'
import styles from './EFTextField.module.scss'

const cx = classNames.bind(styles)

export const EFHorizontalTextField = forwardRef(
  (props: EFHorizontalTextFieldProps, _ref: ForwardedRef<unknown>) => {
    const { control } = useFormContext() ?? {}
    const theme = useAppSelector(currentTheme)
    const { labelWidth = 2, labelAlign = 'left', ...otherProps } = props
    if (!control) return <CustomHorizontalTextField {...props} />
    return (
      <Controller
        control={control}
        name={props.name}
        render={({ field }) => (
          <Grid
            paddingBottom={2}
            container
            spacing={2}
            alignItems='center'
          >
            {props.label && (
              <Grid
                item
                xs={labelWidth}
                md={labelWidth}
                textAlign={labelAlign}
                paddingRight={3}
              >
                <EFInputLabel
                  label={props.label}
                  name={props.name}
                  sx={props.labelSx}
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={12 - labelWidth}
            >
              <TextField
                {...otherProps}
                {...field}
                autoComplete='new-password'
                className={cx('text-field', theme)}
                type={props.type}
                name={field.name}
                value={field.value || ''}
                placeholder={props.placeholder}
                id={field.name}
                FormHelperTextProps={{
                  sx: { marginX: 0, color: 'red !important' }
                }}
                InputLabelProps={{ sx: { display: 'none' }, shrink: false }}
              />
            </Grid>
          </Grid>
        )}
      />
    )
  }
)
